var modules_80570563 = {"container":"_15lw30p","button":"_mfhpq4","active":"_1ve2xza","disabled":"_1rqevrr","size-36":"_kjl45h","size-44":"_uak5x8","size-52":"_1iazxmz","with-border":"_1zq8hu"};
import "../../../assets/xOZqUtAe.css";

export { modules_80570563 as default };
//# sourceMappingURL=RadioButton.module.less.js.map
